'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var RUS = exports.RUS = 'rus';
var ENU = exports.ENU = 'enu';

var LANGUAGES = exports.LANGUAGES = {
    en: ENU,
    ru: RUS
};